import React from 'react';
// @ts-ignore
import styles from './CaseForwardConfirm.module.scss';
import Form from '../../../../Components/Form/Form';
import FormControl from '../../../../Components/Form/FormControl';
import TextArea from '../../../../Components/Base/TextArea/TextArea';
import Text from '../../../../Components/Base/Text/Text';
import { useReAssignCaseMutation } from '../../../../graphql/graphql';
import withForm from '../../../../Components/Form/withForm';
import { useFormContext } from '../../../../Components/Form/FormContext';
import ConfirmButton from '../../../../Components/Button/ConfirmButton';
import CancelButton from '../../../../Components/Button/CancelButton';

interface Props {
	caseId: string;
	label: string;
	workplaceId?: string;
	workplaceMemberId?: string;
	onClose: () => void;
	onCaseForward: () => void;
}

const CaseForwardConfirm: React.FC<Props> = ({
	caseId,
	label,
	workplaceId,
	workplaceMemberId,
	onClose,
	onCaseForward,
}) => {
	const [reAssignCase] = useReAssignCaseMutation();
	const { formMethods } = useFormContext();

	const handleConfirm = async () => {
		const formValues = formMethods.getValues();
		await reAssignCase({
			caseId,
			workplaceId,
			workplaceMemberId,
			note: formValues.note,
		}).unwrap();
		onCaseForward();
	};

	return (
		<div className={styles.wrapper}>
			<div className={styles.content}>
				<div className={styles.text}>
					<Text tx='base.shared.caseTransferConfirmation' inline />{' '}
					<Text tx={label} className={styles.name} inline />
				</div>
			</div>
			<Form>
				<FormControl label='base.shared.note' name='note'>
					<TextArea />
				</FormControl>
			</Form>
			<div className={styles.controls}>
				<CancelButton onClick={() => onClose()} />
				<ConfirmButton onClick={handleConfirm} />
			</div>
		</div>
	);
};

export default withForm(CaseForwardConfirm);
